// src/components/StocksNavbar.jsx
import React from "react";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";

const BLUE = "#1677ff";

/* Phase 2B — picking a market from the dropdown navigates to that market's
   own URL (so every market is bookmarkable, shareable and Google-indexable).
   Keep this map in sync with PATH_TO_MARKET in StocksOutlet.jsx. */
const MARKET_TO_PATH = {
  tadawul: "/stocks/tadawul",
  nasdaq: "/stocks/nasdaq",
  dj: "/stocks/dj",
  us: "/stocks/sp500",
  psx: "/stocks/psx",
  nse: "/stocks/nse",
  egx: "/stocks/egx",
  qse: "/stocks/qse",
  dfm: "/stocks/dfm",
};

const Container = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 40px;
  background-color: #fff;
  z-index: 1000;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  padding-left: 240px;
  padding-right: 155px;

  @media only screen and (max-width: 768px) {
    padding-left: 10px;
    padding-right: 125px;
    height: 40px;
  }
`;

const Wrapper = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;

  @media only screen and (max-width: 768px) {
    padding: 0 10px;
    gap: 10px;
  }
`;

const Left = styled.div`
  display: flex;
  align-items: center;
  gap: 25px;

  @media only screen and (max-width: 768px) {
    gap: 10px;
  }
`;

const Right = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;

  @media only screen and (max-width: 768px) {
    gap: 6px;
  }
`;

const MenuItem = styled.div`
  font-size: 14px;
  cursor: pointer;
  transition: color 0.3s ease;
  &:hover {
    color: teal;
  }
`;

const DaysBackControl = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;

  @media only screen and (max-width: 768px) {
    display: none;
  }
`;

const MarketControl = styled.div`
  display: ${(props) => (props.hidden ? "none" : "flex")};
  align-items: center;
  gap: 6px;

  label {
    color: ${BLUE};
    font-weight: 600;
  }

  select {
    color: ${BLUE};
    font-weight: 600;
    border: 2px solid ${BLUE};
    border-radius: 6px;
    padding: 4px 8px;
    width: 280px;
    background: #fff;
  }

  @media only screen and (max-width: 768px) {
    label {
      display: none;
    }
    select {
      padding: 3px 6px;
      font-size: 12px;
      width: auto;
      max-width: 150px;
    }
  }
`;

export default function StocksNavbar({
  market,
  setMarket,
  daysBack,
  setDaysBack,
  hideMarket,
}) {
  const navigate = useNavigate();


  const handleMarketChange = (e) => {
    const newMarket = e.target.value;
    setMarket(newMarket);
    const path = MARKET_TO_PATH[newMarket];
    if (path) navigate(path);
  };

  return (
    <Container>
      <Wrapper>
        <Left>
          <MenuItem onClick={() => navigate("/")}>🏠 Home</MenuItem>
        </Left>

        <Right>
          <DaysBackControl>
            <label>Days Back:</label>
            <input
              type="number"
              value={daysBack}
              onChange={(e) => setDaysBack(Number(e.target.value))}
              style={{ width: "60px", padding: "4px" }}
            />
          </DaysBackControl>

          <MarketControl hidden={hideMarket}>
            <label style={{ marginRight: 6 }}>Market:</label>
            <select value={market} onChange={handleMarketChange}>
              <option value="dj">Dow Jones DJ</option>
              {/*<option value="tadawul">Tadawul 🇸🇦</option>*/}
              <option value="nasdaq">Nasdaq 🇺🇸</option>
              <option value="psx">Pakistan PSX 🇵🇰</option>
              <option value="nse">India NSE 🇮🇳</option>
              <option value="egx">Egypt EGX 🇪🇬</option>
              <option value="qse">QATAR QSE QA</option>
              <option value="dfm">DUBAI DFM EM</option>
              <option value="us">SP500</option>
            </select>
          </MarketControl>
        </Right>
      </Wrapper>
    </Container>
  );
}
